import React from 'react';
import { Github, Twitter, Linkedin, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';

const SECTIONS = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '/#features' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Showcase', href: '/showcase' },
      { label: 'Changelog', href: '#' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '#' },
      { label: 'Blog', href: '#' },
      { label: 'Careers', href: '#' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Documentation', href: '#' },
      { label: 'Templates', href: '#' },
      { label: 'Community', href: '#' },
      { label: 'Support', href: '/contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Cookies', href: '/privacy' },
      { label: 'Acceptable Use', href: '/terms' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative bg-neutral-950 text-neutral-300">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16">
        <div className="grid lg:grid-cols-6 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5" data-testid="footer-brand-link">
              <img
                src="/logo.png"
                alt="Transformerus"
                className="w-9 h-9 object-contain"
                data-testid="footer-brand-logo"
              />
              <span className="tfu-logo text-[20px] text-white tracking-tight">transformerus</span>
            </Link>
            <p className="mt-4 text-sm text-neutral-400 max-w-sm">
              The fastest way to ship a full-stack app. Describe it. Watch agents build it. Deploy in one click.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Github, Twitter, Linkedin, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-neutral-900 hover:bg-neutral-800 border border-neutral-800 flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {SECTIONS.map((s) => (
            <div key={s.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{s.title}</h4>
              <ul className="space-y-2.5">
                {s.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-neutral-400 hover:text-white transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-neutral-900 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="space-y-1">
            <p className="text-xs text-neutral-500">
              © {new Date().getFullYear()} Transformerus, Inc. All rights reserved.
            </p>
            <p className="text-xs text-neutral-600">Powered by GET Corp LP</p>
          </div>
          <p className="text-xs text-neutral-500">Made with Transformerus.</p>
        </div>
      </div>
    </footer>
  );
}
